import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showAdPopup, hideAdPopup } from "../Redux Store/Slice";
import "./AdvertisementPopup.css";

const AdvertisementPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const visible = useSelector((state) => state.appstate.ad_popup);
  const [popupData, setPopupData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch popup data from API
  useEffect(() => {
    const fetchPopupData = async () => {
      try {
        const response = await fetch("https://backend-wellshape.vercel.app/admin/popup");
        const data = await response.json();
        setPopupData(data);
      } catch (error) {
        console.error("Error fetching popup data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPopupData();
  }, []);

  // Handle popup visibility logic
  useEffect(() => {
    if (loading || !popupData) return;

    const popupStorage = localStorage.getItem("advertisementPopup");
    const now = new Date().getTime();

    if (!popupStorage) {
      // First visit
      localStorage.setItem(
        "advertisementPopup",
        JSON.stringify({ seen: true, time: now })
      );
      dispatch(showAdPopup());
    } else {
      const { time } = JSON.parse(popupStorage);
      const hoursPassed = (now - time) / (1000 * 60 * 60);

      if (hoursPassed > 2) {
        localStorage.setItem(
          "advertisementPopup",
          JSON.stringify({ seen: true, time: now })
        );
        dispatch(showAdPopup());
      }
    }
  }, [dispatch, loading, popupData]);

  const closePopup = () => {
    dispatch(hideAdPopup());
  };

  const goToDetails = () => {
    dispatch(hideAdPopup());
    if (popupData?.link) {
      // Check if it's an external link or internal route
      if (popupData.link.startsWith('http')) {
        window.location.href = popupData.link;
      } else {
        navigate(popupData.link);
      }
    }
  };

  // Don't render if not visible, still loading, or no data
  if (!visible || loading || !popupData) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="popup-close" onClick={closePopup}>
          &times;
        </button>

        <h2 className="popup-title">{popupData.title}</h2>

        <img
          src={popupData.image_url}
          alt={popupData.title}
          className="popup-image"
        />

        <p className="popup-text">{popupData.description}</p>

        {popupData.link && (
          <button className="popup-btn" onClick={goToDetails}>
            SHOP NOW
          </button>
        )}
      </div>
    </div>
  );
};

export default AdvertisementPopup;